type Sort = {
  desc: boolean;
  id: number | string;
};

type SortableColumn = {
  id: number | string;
  sortId?: string;
};

export const buildSortQuery = (
  sorts: Sort[],
  columns: SortableColumn[]
): string =>
  sorts
    .flatMap((sort) => {
      const column = columns.find(({ id }) => id === sort.id);
      const sortIds = (column?.sortId || String(sort.id))
        .split(',')
        .map((id) => id.trim())
        .filter(Boolean);

      return sortIds.map((id) => `${sort.desc ? '-' : ''}${id}`);
    })
    .join(',');
